import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbNavProps {
  path: string;
  onNavigate: (path: string) => void;
}

export default function BreadcrumbNav({ path, onNavigate }: BreadcrumbNavProps) {
  // Split the path into segments
  const segments = path === '/' ? [] : path.split('/').filter(Boolean);

  // Generate breadcrumb items with their full paths
  const breadcrumbs = segments.map((segment, index) => {
    // Build the path up to this segment
    const segmentPath = `/${segments.slice(0, index + 1).join('/')}`;
    return { name: segment, path: segmentPath };
  });

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        <li>
          <div>
            <button
              onClick={() => onNavigate('/')}
              className={`flex items-center transition-colors duration-200 ${
                path === '/'
                  ? 'font-semibold text-gray-900 dark:text-gray-100 cursor-default'
                  : 'text-gray-500 dark:text-gray-400 hover:text-[#E34290] dark:hover:text-[#E34290]'
              }`}
              disabled={path === '/'}
            >
              <Home className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </button>
          </div>
        </li>

        {breadcrumbs.map((breadcrumb) => (
          <li key={breadcrumb.path}>
            <div className="flex items-center">
              <ChevronRight
                className="h-4 w-4 flex-shrink-0 text-gray-400 dark:text-gray-500"
                aria-hidden="true"
              />
              <button
                onClick={() => onNavigate(breadcrumb.path)}
                className={`ml-2 text-sm font-medium transition-colors duration-200 ${
                  breadcrumb.path === path
                    ? 'font-semibold text-gray-900 dark:text-gray-100 cursor-default'
                    : 'text-gray-500 dark:text-gray-400 hover:text-[#E34290] dark:hover:text-[#E34290]'
                }`}
                disabled={breadcrumb.path === path}
              >
                {breadcrumb.name}
              </button>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
